import { render, staticRenderFns } from "./Create-Or-Update-Bills.vue?vue&type=template&id=a6b51dc6&scoped=true"
import script from "./Create-Or-Update-Bills.vue?vue&type=script&lang=js"
export * from "./Create-Or-Update-Bills.vue?vue&type=script&lang=js"
import style0 from "./Create-Or-Update-Bills.vue?vue&type=style&index=0&id=a6b51dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b51dc6",
  null
  
)

export default component.exports